module.exports = __webpack_public_path__ + "img/notifications.a71d4eab.svg";